import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { HiOutlineTrash } from 'react-icons/hi'
import Button from '../../../components/General/Button'
import { ItemToTransfer } from './Transfers'
import placeholder from '../../../assets/images/img-placeholder.jpg'
import { AiOutlineBarcode } from 'react-icons/ai'
import { IExistence, IWarehouse } from 'safe'
import { getStatusColors } from './ShowExistence'
import { formatAmount } from '../../../utils/utils'
import axios from 'axios'
import useSnackBars from '../../../hooks/SnackbarConsumerHook'
const server = process.env.REACT_APP_SERVER_URL

const ShowItemsReady: React.FC<ShowItemsReadyProps> = ({
  itemsReady,
  setItemsReady,
  destination,
  execute,
  buttonText = null,
  secondStage = false,
}) => {
  const { addAlert } = useSnackBars()

  const [existences, setExistences] = useState<IExistence[]>([])

  // Contrived code, just to save the preexisting existence on destination
  // before the transference

  // useEffect(() => {
  //   if (destination) fetchExistencesOnTheFly()
  // }, [destination])

  const fetchExistencesOnTheFly = async (
    pattern: string = ''
  ): Promise<void> => {
    addAlert({
      message: 'Cargando Existencias...',
      status: 'loading',
    })
    try {
      const url =
        pattern === ''
          ? `${server}/inventory/existence/search/custom/${
              destination && destination.id
            }/`
          : `${server}/inventory/existence/search/custom/${
              destination && destination.id
            }?searchCustom=${pattern}`

      let response = await axios.get(url)

      setExistences(response.data.existences)
      addAlert({
        message: 'Existencias en Destino cargadas',
        status: 'success',
      })
    } catch (error: any) {
      addAlert({
        message: 'Error al cargar existencias de destino',
        status: 'error',
      })
    }
  }

  const changeQuantity = (itemToModify: ItemToTransfer, quantity: string) => {
    const itemsReadyCopy = [...itemsReady]
    const index = itemsReadyCopy.findIndex(
      (item) => item.id === itemToModify.id
    )
    itemsReadyCopy[index] = { ...itemsReadyCopy[index], quantity: +quantity }
    setItemsReady(itemsReadyCopy)
  }

  console.log('itemsReady', itemsReady)

  if (itemsReady?.length > 0) {
    return (
      <>
        <input
          type="text"
          className="mt-1 mb-2"
          style={{ borderWidth: '0px', visibility: 'hidden' }}
        />
        <div className="divide-y-2 divide-white h-80 overflow-y-scroll">
          {itemsReady.map((itemReady, idx) => (
            <div
              key={itemReady?.id}
              className="flex hover:bg-gray-50 items-center px-3 py-2 space-between space-x-3 dark:bg-black overflow-auto"
            >
              <Button
                onClick={() => {
                  const itemsReadyCopy = [...itemsReady]?.filter(
                    (x, index) => index !== idx
                  )

                  setItemsReady(itemsReadyCopy)
                }}
                type="link"
                classes="dark:text-primary-600"
                danger
                icon={<HiOutlineTrash size="22" />}
              />
              <img
                className="h-10 w-10 object-cover rounded-lg shadow-inner"
                src={itemReady?.image || placeholder}
                alt={itemReady?.sku}
              ></img>
              <div className="flex items-center space-y-1 justify-between md:space-x-3 flex-grow">
                <div className="ml-4 flex-grow">
                  <p className="font-semibold text-base text-gray-600 capitalize mb-2 dark:text-white">
                    {itemReady?.name}
                  </p>
                  <div className="flex items-center justify-between text-sm text-gray-500">
                    <div>
                      {/* {itemReady?.barcode ? (
                        <>
                          <AiOutlineBarcode className="mr-1 mb-1 text-gray-400 inline" />
                          {itemReady?.barcode}
                        </>
                      ) : (
                        'Sin código de barras'
                      )} */}
                    </div>
                    <div>
                      {itemReady?.sku ? `SKU: ${itemReady?.sku}` : 'Sin SKU'}
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    className={
                      'text-right max-w-[300px] rounded-xl p-1 px-2 mb-1 bg-gray-200 text-gray-500 flex flex-row justify-between space-x-3'
                    }
                  >
                    <div>
                    <div className="flex flex-row justify-between">
                      <div className="text-primary-900 text-left mr-2">
                        Cantidad disponible en almacén de origen:
                      </div>
                      <div
                        className="text-primary-900 mr-[10px]"
                        // className={`${getStatusColors(+itemReady.originAvailable).text
                        //   } opacity-50`}
                      >
                        {itemReady?.originAvailable}
                      </div>
                    </div>

                    <div className="flex flex-row justify-between">
                      <div className="text-primary-900 text-left">
                        Cantidad:
                      </div>
                      <input
                        type="number"
                        style={{
                          height: '22px',
                          marginTop: '2px',
                          marginLeft: '8px',
                          textAlign: 'right',
                          width: '76px',
                          background: 'transparent',
                          border: 'none',
                        }}
                        value={itemReady?.quantity?.toString()}
                        onChange={(e) =>
                          changeQuantity(itemReady, e.target.value)
                        }
                        min="1"
                      />
                    </div>

                      </div>
                    {/* <div>
                      <div className="text-primary-900 text-left">Cantidad disponible en almacén de origen:</div>

                      <div className="text-primary-900 text-left">Cantidad:</div>
                    </div>


                    <div>
                      <div
                        className='text-primary-900 mr-[10px]'
                        // className={`${getStatusColors(+itemReady.originAvailable).text
                        //   } opacity-50`}
                      >
                        {itemReady?.originAvailable}
                      </div>
                      <input
                        type="number"
                        style={{
                          height: '22px',
                          marginTop: '2px',
                          marginLeft: '8px',
                          textAlign: 'right',
                          width: '76px',
                          background: 'transparent',
                          border: 'none',
                          
                        }}
                        value={itemReady?.quantity?.toString()}
                        onChange={(e) =>
                          changeQuantity(itemReady, e.target.value)
                        }
                        min="1"
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <Button
          classes="items-center w-full h-12 mt-5"
          disabled={!destination}
          onClick={() => execute()}
          type={!secondStage ? 'primary' : 'outline'}
        >
          <span className="text-base mr-6">
            {!secondStage ? buttonText || 'Transferir' : 'Atrás'}
          </span>
        </Button>
      </>
    )
  }
  return <></>
}

export default ShowItemsReady

interface ShowItemsReadyProps {
  itemsReady: ItemToTransfer[]
  setItemsReady: Dispatch<SetStateAction<ItemToTransfer[]>>
  destination: IWarehouse | null
  execute: Function
  buttonText?: string | null
  secondStage?: boolean
}
